export const shadowBox = (colors) => {
  return {
    backgroundColor: colors.primary[700],
    borderRadius: "8px",
    margin: "10px",
    my: "15px",
    padding: "16px",
    border: `1px solid ${colors.grey[800]}`,
    boxShadow: "0 1px 4px rgba(31,41,55,0.06)",
  };
};

export const borderBox = (colors) => {
  return {
    backgroundColor: colors.primary[700],
    borderRadius: "8px",
    margin: "5px",
    padding: "16px",
    border: 1,
    borderColor: colors.grey[800],
  };
};
export const simpleCardStyle = (colors, borderColor = colors.grey[800]) => {
  return {
    border: `1px solid ${borderColor}`,
    padding: "16px",
    backgroundColor: colors.primary[700],
    borderRadius: "8px",
    boxShadow: "0 1px 4px rgba(31,41,55,0.06)",
    height: "100%",
  };
};
